// @flow

import qs from 'qs';
import Api from './ApiBase';

const getOneParams = (params: any) => qs.stringify({
  ...params,
  include: 'user,regions,industries,categories,work_types,entry_levels,job_languages,number_employees_groups'
});

class JobAlertApi extends Api {
  serializerType = 'job_alerts';

  serializerOptions = {
    attributes: [
      'enabled', 'keywords', 'name', 'user', 'regions', 'industries', 'categories', 'work_types',
      'entry_levels', 'job_languages', 'number_employees_groups', 'place', 'distance'
    ],
    user: { ref: 'id' },
    regions: { ref: 'id' },
    industries: { ref: 'id' },
    categories: { ref: 'id' },
    work_types: { ref: 'id' },
    entry_levels: { ref: 'id' },
    job_languages: { ref: 'id' },
    number_employees_groups: { ref: 'id' },
    place: { ref: 'id' }
  };

  create = async (params: {}) => {
    const body = await this.serialize(params);
    const json = await this.request(`job_alerts?${getOneParams(params)}`, { body: JSON.stringify(body), method: 'POST' });
    const data = await this.deserialize(json);

    return { data };
  }
}

export default new JobAlertApi();
